import { dcolors, dlog } from "corexxx";
import { useDAppCommand } from "../../libs/dweb/DAppCommand";
import {
  DPageRootLayout,
  DPageRootLayoutWithDrawer,
} from "../../libs/dweb/DPageRootLayout";
import { useMoney } from "../models/Hook";
import { useEffect } from "react";

import { YearBudget } from "./YearBudgetPage";
import { NetWorthView } from "./NetWorthPage";
import { DNeedsLogin } from "../../libs/dweb/DNeedsLogin";
import { AdvanceAnalysisView } from "./AdvanceAnalysisPage";
import { DText } from "../../libs/dweb/DText";
import { DResponsiveWindow } from "../../libs/dweb/DResponsiveWindow";
import { DBox } from "../../libs/dweb/DBox";
import { StockAnalysisView } from "./StockAnalysisPage";
import { StockTrendsFinderView } from "./StockTrendFinderPage";
import React from "react";

export function DashBoard() {
  let appCommand = useDAppCommand();
  let moneyComamnd = useMoney();

  // Init once
  useEffect(() => {
    moneyComamnd.api.onInit();
  }, []);


  return (
    <DNeedsLogin>
      <DPageRootLayout
        config={{
          title: "Grodok Money",
          appBarConfig: {
            // appBarRightJSX: <DRefreshButton style={{ color: 'white' }} onClick={hook.api.loadBrokerAccountInfo} />
          },
          topNavigation: [
            {
              title: "⏰ Net Worth",
              screen: <NetWorthView />,
            },
            {
              title: "💹 SPX Analysis",
              screen: <AdvanceAnalysisView />,
            },
            {
              title: " 🚀 Stock Analysis",
              screen: <StockAnalysisView />,
            },
            {
              title: " 🚀 Stock Trends Finder",
              screen: <StockTrendsFinderView />,
            }
          ],
          showMoneyPrivacy: true,
        }}
      >
        <DResponsiveWindow>
          <DBox innerStyle={{ textAlign: 'center', justifyContent: 'center' }}>
            <DText style={{ fontSize: 30 }}>Welcome <span>{appCommand.state.accountState?.name}</span></DText>
            <DText>Please select a menu in top for getting started</DText>
          </DBox>
        </DResponsiveWindow>

      </DPageRootLayout>
    </DNeedsLogin>
  );
}
